// extracted by mini-css-extract-plugin
module.exports = {"control":"Input-m__control___Tl7NI"};